import React, { useState, useEffect } from 'react';
import classNames from "classnames";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';
import Close from '@material-ui/icons/Close';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import Check from "@material-ui/icons/Check";

import Downshift from 'downshift';
import * as constants from "variables/constants.jsx";
import { doAjax, doAjaxPost } from "variables/common.js";
import { IntegrationReactSelect } from "components/Sidebar/FilterSidebar.jsx";
import MenuItem from '@material-ui/core/MenuItem';

import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from "@material-ui/core/InputLabel";
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";

import CustomInput from "components/CustomInput/CustomInput.jsx";
import Select from 'react-select';

import withStyles from "@material-ui/core/styles/withStyles";

const styles = {
  tableWrapper: {
    "& > table > tbody": {
      overflow: "auto",
      maxHeight: "70vh"
    },
    "& > table td": {
      paddingLeft: "10px",
      paddingRight: "15px"
    },
    "& > table td:nth-child(1)": {
      paddingLeft: "24px",
    },
    "& > table th": {
      paddingLeft: "10px",
      paddingRight: "15px"
    },
    "& > table th:nth-child(1)": {
      paddingLeft: "24px",
    },
    "& > table td:last-child": {
      paddingRight: "15px",
      maxWidth: "80px",
    },
    maxHeight: "calc(100vh - 60px - 64px - 56px - 74px)",
    overflow: "auto",
  },
  editButton: {
    margin: 0,
    verticalAlign: "middle",
    padding: 0,
    height: "21px",
    minWidth: "1px",
    backgroundColor: "transparent",
    "&:hover": {
      backgroundColor: "transparent",
    }
  },
  editIcon: {
    margin: 0,
    verticalAlign: "middle",
    padding: 0,
    height: "21px",
    minWidth: "21px",
    color: "#848484",
    backgroundColor: "transparent",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
}

const BannerEditor = ({ i18n, classes, handleProgressBarOpen, handleProgressBarClose, handleShowSnackbar, value, saveContent, setValue, supplierArticleId }) => {
  const [imagesArr, setImagesArr] = useState([])
  const [categorySuggestions, setCategorySuggestions] = useState([])
  const [urlSuggestions, setUrlSuggestions] = useState('')
  const [imagesString, setImagesString] = useState()

  const [categoryInput, setCategoryInput] = useState('');
  
  const [categoriesAll, setCategoriesAll] = useState([]);
  const [categoriesSelected, setCategoriesSelected] = useState([]);
  const [vendorsAll, setVendorsAll] = useState([]);
  const [vendorsSelected, setVendorsSelected] = useState([]);
  
  function init() {

	var user = JSON.parse(localStorage.getItem('user')).value;
	//key=' + constants.apiKey + "&principalId=" + user.id + "&supplierId=" + localStorage.getItem('supplierId') + '&upd=' + new Date().getTime()
	var categoriesUrl = constants.apiBaseUrl + '/b2b/supplier/categories?';
	//key=' + constants.apiKey + "&principalId=" + user.id + "&supplierId=" + localStorage.getItem('supplierId') + '&upd=' + new Date().getTime() + '
	categoriesUrl = constants.apiBaseUrl + '/b2b/supplier/category/search?&s=';

    var cb = function (data) {
      setCategoriesAll(data);
    }
	doAjax(categoriesUrl, cb, handleProgressBarClose, handleShowSnackbar);
	
	//key=' + constants.apiKey + "&principalId=" + user.id + "&supplierId=" + localStorage.getItem('supplierId') + '&upd=' + new Date().getTime() + '
	var vendorsUrl = constants.apiBaseUrl + '/b2b/supplier/vendor/search?&s=';

    var cb = function (data) {
      // alert(data);
      setVendorsAll(data);
    }
	doAjax(vendorsUrl, cb, handleProgressBarClose, handleShowSnackbar);
	
  };

  const handleCategoryChange = event => {

    var user = JSON.parse(localStorage.getItem('user')).value;

	//key=' + constants.apiKey + "&principalId=" + user.id + "&supplierId=" + localStorage.getItem('supplierId') + '&upd=' + new Date().getTime() + "
    var url = constants.apiBaseUrl + '/b2b/supplier/category/search?&s=' + document.getElementById('category-options-input').value;

    var cb = function (data) {
      setCategorySuggestions(data);
    }
    handleProgressBarOpen();
    doAjax(url, cb, handleProgressBarClose, handleShowSnackbar);
  }
  
  const handleSelectFilterCategory = (event, categories) => {
  
  	setCategoriesSelected(categories);
  
  }
  
  const handleSelectFilterVendor = (event, vendors) => {
  
  	setVendorsSelected(vendors);
  
  }

  function renderInput(inputProps) {
    const { InputProps, classes, ref, ...other } = inputProps;

    return (
      <TextField
        InputProps={{
          inputRef: ref,
          classes: {
            root: classes.inputRoot,
            input: classes.inputInput,
          },
          ...InputProps,
        }}
        {...other}
      />
    );
  }

  function getSuggestions(value, { showEmpty = false } = {}, suggestions) {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;
    let count = 0;

    return inputLength === 0 && !showEmpty
      ? []
      : suggestions;
  }

  function renderSuggestion(suggestionProps) {
    const { suggestion, index, itemProps, highlightedIndex, selectedItem } = suggestionProps;
    const isHighlighted = highlightedIndex === index;
    const isSelected = (selectedItem || '').indexOf(suggestion) > -1;

    return (
      <MenuItem
        {...itemProps}
        key={suggestion.id}
        selected={isHighlighted}
        component="div"
        style={{
          fontWeight: isSelected ? 500 : 400,
          fontSize: "14px"
        }}
      >
        <span style={{ marginLeft: "0px" }}>{suggestion}</span>
      </MenuItem>
    );
  }

  const handleAddImageURLClick = (event) => {
  
    var urlSuggestions = document.getElementById('url-input').value;

    if (urlSuggestions == null || urlSuggestions == 0) {
      alert("Пожалуйста, заполните ссылку");
      return;
    }

    // var category = document.getElementById('categories-input').value;
    
    // var category = document.getElementById('vendors-input').value;

    //if (category == null || category == 0) {
    //  alert("Пожалуйста, заполните категорию");
    //  return;
    //}
    
    // alert(categoriesSelected);
    
    // alert(categoriesSelected.join("&&&"));

    setImagesArr(prevImages => {
      const updatedImages = [...prevImages, { url: urlSuggestions, categories: categoriesSelected.join("&&&"), vendors: vendorsSelected.join("&&&"), promo: document.getElementById('discounts-cb').checked ? 1 : 0 }] // category, 

      const result = updatedImages.map(item => `${item.url}|||${item.categories}|||${item.vendors}|||${item.promo}`).join("\n");

      //setValue(result);
      saveContent(result);

      return updatedImages;
    })

    // setUrlSuggestions('');
    
    document.getElementById('url-input').value = '';
  }

  const handleDeleteImage = (index) => {
    if (!window.confirm("Удалить ссылку?")) {
      return;
    }
    setImagesArr(prevImage => {
      const updatedImages = prevImage.filter((_, i) => i != index);

      const result = updatedImages.map(item => `${item.url}|||${item.categories}|||${item.vendors}|||${item.promo}`).join("\n");
      saveContent(result);

      return updatedImages;
    })
  }


  useEffect(() => {
  	// alert(1);
    if (value) {
      setImagesArr([])
      const textLine = value.split("\n");
      textLine.forEach((imageInfo) => {
        const [url, categories, vendors, promo] = imageInfo.split('|||');
        setImagesArr(prevImages => [...prevImages, { url, categories, vendors, promo }]);
      })
    } else {
      setImagesArr([])
    }
    
    init();
    
  }, [value])
  
  var draggingIndex = null;
  var dragEl = null;
  var dropIndex = null;
  var dragIndex = null;
  
  function dragOver(e, index) {
     
      e.preventDefault();
  
      if (e.target.parentNode.tagName !== 'TR') {
      	return;
      }
      
      dragEl.style.border = "1px dashed gray";
      
      // alert(draggingIndex + ' - ' + index);
      
      // alert(this.state.imagesArr);
      
      // alert(imagesArr);
  
  	  if (draggingIndex == index) {
  	  	return;
  	  }
  	  
  	  // alert(draggingIndex + ' - ' + index);
  	  // alert(imagesArr[draggingIndex].url + ' - ' + imagesArr[index].url)
  	  
  
      //var tmp = imagesArr[draggingIndex];
      //imagesArr[draggingIndex] = imagesArr[index];
      //imagesArr[index] = tmp;
      //setImagesArr(imagesArr);
      // setImagesArr([])
      // this.setState({ state: this.state });
      // setState({ state: this.state });
      
      // alert(imagesArr[draggingIndex].url + ' - ' + imagesArr[index].url)
  
      dragIndex = Array.from(e.target.parentNode.parentNode.children).indexOf(dragEl) - 1;
  
	  if (isBefore(dragEl, e.target.parentNode)) 
	  {
	    e.target.parentNode.parentNode.insertBefore(dragEl, e.target.parentNode);
	  } else {
	    e.target.parentNode.parentNode.insertBefore(dragEl, e.target.parentNode.nextSibling);
	  }
	  
      dropIndex = Array.from(e.target.parentNode.parentNode.children).indexOf(dragEl) - 1;
	  // alert(dropIndex);
	  
	  var tmp = imagesArr[dragIndex];
      imagesArr[dragIndex] = imagesArr[dropIndex];
      imagesArr[dropIndex] = tmp;
	  
	  const result = imagesArr.map(item => `${item.url}|||${item.categories}|||${item.vendors}|||${item.promo}`).join("\n");
	  // alert(result);

      //setValue(result);
      //saveContent(result);
	    
	  // alert('over ' + e.target.parentNode);  
  }
  
  function dragStart(e, index) {
    
    if (e.target.tagName !== 'TR') {
      	return;
    }
  
    draggingIndex = index;
    dragEl = e.target;
    // alert('start ' + dragEl);
    // alert('start ' + index);
  }
  
  function dragEnter(e, index) {
    if (draggingIndex === null || index === draggingIndex) return;

    e.preventDefault();
    e.dataTransfer.dropEffect = "move";

 	e.target.parentNode.style.border = "1px solid gray";

    // draggingIndex = index;
    
    // alert('enter ' + index);
  }

  function dragLeave(e, index) {
    if (draggingIndex === null || index === draggingIndex) return;

    e.preventDefault();
    

 	e.target.parentNode.style.border = "";

    // draggingIndex = index;
    
    // alert('enter ' + index);
  }
  
  
  function dragEnd(e) {
  
    // alert('end ' + e.target + ' - ' + e.target.nextSibling + ' - ' + dragEl + ' - ' + e.target.parentNode);
  
    //const newNode = document.createElement("li");
    //newNode.textContent = "Apple";
    
    e.target.parentNode.style.border = "";
  
    //e.target.parentNode.insertBefore(newNode, e.target.nextSibling);
    
  	// dragEl = null;
  	
  	
  }
  
  function drop(e, index) {
  
    if (!dragEl) {
    	return;
    }
  
    // alert('drop ' + e.target + ' - ' + e.target.nextSibling + ' - ' + dragEl + ' - ' + e.target.parentNode);
  
    //const newNode = document.createElement("li");
    //newNode.textContent = "Apple";

    //const dropTarget = e.target.closest('tr');
    //var dropIndex = dropTarget ? Array.from(e.target.parentNode.parentNode.children).indexOf(dropTarget) : e.target.parentNode.parentNode.children.length;
  
    // e.target.parentNode.parentNode.insertBefore(dragEl, e.target.parentNode.nextSibling);
    //if (isBefore(dragEl, e.target.parentNode)) {
	//    e.target.parentNode.parentNode.insertBefore(dragEl, e.target.parentNode);
	//} else {
	//    e.target.parentNode.parentNode.insertBefore(dragEl, e.target.parentNode.nextSibling);
	//}
  
	// dropIndex = Array.from(e.target.parentNode.parentNode.children).indexOf(dragEl);
    
    // alert(draggingIndex + ' - ' + index + ' - ' + dropIndex);
  	//alert(imagesArr[draggingIndex].url + ' - ' + imagesArr[index].url)
    
    //alert(draggingIndex + ' - ' + dragIndex + ' - ' + dropIndex);
        
    //var tmp = imagesArr[dragIndex];
    //imagesArr[dragIndex] = imagesArr[dropIndex];
    //imagesArr[dropIndex] = tmp;
    
    setImagesArr(imagesArr);
    
    dragEl.style.border = "";
    
  	dragEl = null;
  	draggingIndex = null;
  	dropIndex = null;
  	
  	const result = imagesArr.map(item => `${item.url}|||${item.categories}|||${item.vendors}|||${item.promo}`).join("\n");
  	//alert(result);

    //setValue(result);
    //saveContent(result);
  	
  	saveArticle(result);
  }
  
  function saveArticle(text) {
	var user = JSON.parse(localStorage.getItem('user')).value;
    var supplierUser = JSON.parse(localStorage.getItem('supplierUser')).value;

	//key=' + constants.apiKey + '&upd=' + new Date().getTime()
    var url = constants.apiBaseUrl + '/b2b/supplier/article/update?';

	// + "&supplierId=" + supplierUser.supplierId
	//"&principalId=" + user.id
    var body = "&supplierArticleId=" + supplierArticleId + 
    		   "&text=" + text.replace(/%/g, "%25").replace(/\+/g, "%2B").replace(/&/g, "%26") + "&type=";
        body += 3;
       
    //handleProgressBarOpen();
    //handleProgressBarClose();
    // handleProgressBarClose
    doAjaxPost(url, body, null, null);  
  } 
  
  function isBefore(el1, el2) {
	  if (el2.parentNode === el1.parentNode)
	    for (var cur = el1.previousSibling; cur && cur.nodeType !== 9; cur = cur.previousSibling)
	      if (cur === el2)
	        return true;
	  return false;
  }

  return (
    <div style={{ marginTop: "25px" }}>
      <>
      
      <GridContainer>
          <GridItem xs={12} sm={12} md={5}>
      
        
        {false &&
        <Downshift id="url-options" style={{ width: "100%" }} initialIsOpen={true} initialInputValue={""} onSelect={selection => {
          if (selection !== null) {
          }
          setUrlSuggestions('');
        }}>
          {({
            getInputProps,
            getLabelProps,
          }) => (
            <div className={classes.container} style={{ width: "100%", marginLeft: "0px", display: "inline-block" }}>
              {renderInput({
                fullWidth: true,
                classes,
                label: i18n.t('imageUrl'),
                InputLabelProps: getLabelProps({ shrink: true }),
                InputProps: {
                  ...getInputProps({
                    value: urlSuggestions,
                    onChange: (event) => {
                      if (event?.target?.value !== undefined) {
                        setUrlSuggestions(event.target.value);
                      }
                    },
                  }),
                },
              })}

            </div>
          )
          }
        </Downshift>
        }  
        
         <CustomInput id="url-input"
                      labelText={i18n.t('ImageUrl')}
                      formControlProps={{
                        fullWidth: true,
                        style: { marginTop: "0px"},
                      }}
                      inputProps={{
                        style: { height: "40px" },
                      }}
                      labelProps={{
                        style: { color: "#bbb !important", fontSize: "inherit" },
                      }}
                    />
        
        </GridItem>
        <GridItem xs={12} sm={12} md={3}>
        	
        	<FormControl fullWidth>
        	<InputLabel shrink
                    label={i18n.t('category')}
                    style={{ width: "100%" }}
            >
            {i18n.t('category')}
            </InputLabel>
	        <IntegrationReactSelect id="categories-input"
	                  	classes={classes}
	                  	suggestions={categoriesAll}
	                  	filterTitle={"category"}
	                  	selectAllFilterItems={handleSelectFilterCategory}
	                  	textFieldStyles={{marginTop: "20px"}}
	                   />
            </FormControl>
	        
	    </GridItem>
	    <GridItem xs={12} sm={12} md={2}>
	    	
	    	<FormControl fullWidth>
	    	
	    	   
	        
	        <InputLabel shrink
                    label={i18n.t('vendor')}
            >
            {i18n.t('vendor')}
            </InputLabel>   

			<IntegrationReactSelect id="vendors-input"
	                  	classes={classes}
	                  	suggestions={vendorsAll}
	                  	filterTitle={"vendor"}
	                  	selectAllFilterItems={handleSelectFilterVendor}
	                  	textFieldStyles={{marginTop: "20px"}}
	                   />
	             
	               
	               
	        {false &&                      
	        <Select id="vendors-input" shrink
	            options={vendorsAll}
	            onChange={handleSelectFilterVendor}
	            placeholder=""
	            isMulti
	            textFieldProps={{
	              label: '',
	              InputLabelProps: {
	                shrink: true,
	              },
	            }}
	          />       
	        }     
	          
	        </FormControl>                         
	    </GridItem>
	    
	    <GridItem xs={12} sm={12} md={1}>
        	
        	<FormControl fullWidth>
        	<InputLabel shrink
                    label={i18n.t('discounts')}
                    style={{ width: "100%" }}
            >
            {i18n.t('discounts')}
            </InputLabel>
	        
	        <FormControlLabel className={classes.filterCheckbox}
		                    control={
		                      <input id="discounts-cb" type="checkbox" style={{transform: "scale(1.5)", marginLeft: "17px", marginTop: "30px"}} /> 
		                    }
		                    
		                    />
	        
            </FormControl>
	        
	    </GridItem>
	        
        {false &&
        <Downshift id="category-options" style={{ width: "20%" }} initialIsOpen={true} initialInputValue={""} onSelect={selection => {
          if (selection !== null) {
            // setCategoryInput(selection);
          }
          setCategorySuggestions([]);
        }}>
          {({
            clearSelection,
            getInputProps,
            getItemProps,
            getLabelProps,
            getMenuProps,
            highlightedIndex,
            inputValue,
            isOpen,
            openMenu,
            selectedItem,
          }) => {
            const { onBlur, onChange, onFocus, ...inputProps } = getInputProps({
              onChange: event => {
                if (event.target.value === '') {
                  clearSelection();
                } else {
                  handleCategoryChange(event);
                }
                {/* setCategoryInput(event.target.value); */ }
              },
              onFocus: openMenu,
            });

            return (
              <div className={classes.container} style={{ width: "20%", marginLeft: "15px", display: "inline-block" }}>
                {renderInput({
                  fullWidth: true,
                  classes,
                  label: i18n.t('category'),
                  InputLabelProps: getLabelProps({ shrink: true }),
                  InputProps: { onBlur, onChange, onFocus },
                  inputProps,
                })}
                {/* inputProps: {
                      ...inputProps,
                      value: categoryInput,
                    }, */}

                <div {...getMenuProps()}>
                  {isOpen ? (
                    <Paper className={classes.paper} square style={{ maxHeight: "200px", overflow: "auto", position: "absolute", zIndex: "100", width: "300px" }}>
                      {getSuggestions(inputValue, { showEmpty: false }, categorySuggestions).map((suggestion, index) =>
                        renderSuggestion({
                          suggestion,
                          index,
                          itemProps: getItemProps({ item: suggestion }),
                          highlightedIndex,
                          selectedItem,
                        }),
                      )}
                    </Paper>
                  ) : null}
                </div>
              </div>
            );
          }}
        </Downshift>
        
        }
        
        
        
        
        <GridItem xs={12} sm={12} md={1} style={{ margin: "auto" }}>
        <Button style={{ verticalAlign: "bottom", marginTop: "8px" }}
          onClick={event => handleAddImageURLClick(event)}
          color="inherit"
          disableRipple
          className={classes.editButton}
        >
          {i18n.t('add')}
        </Button>
        
        </GridItem>
                 
        </GridContainer>

      </>

      <div className={classes.tableWrapper} style={{ maxHeight: "450px", marginTop: "30px", marginBottom: "30px" }}>

        <Table className={classNames()} size={'small'}>
          <TableBody>
            <TableRow >
              <TableCell style={{ width: "40%", paddingLeft: "0px" }}>
                Ссылка на фото 
              </TableCell>
              <TableCell style={{ width: "35%" }}>
                Категория
              </TableCell>
              <TableCell style={{ width: "15%" }}>
                Бренд
              </TableCell>
              <TableCell style={{ width: "5%" }}>
                Скидки
              </TableCell>
              <TableCell style={{ width: "1%" }}>

              </TableCell>
            </TableRow>
            {imagesArr && imagesArr.map((imageLine, index) => {
              return (
                <TableRow hover key={index} draggable style={{cursor: "grab"}}
                  onDragStart={(e) => dragStart(e, index)}
    			  onDragEnter={(e) => dragEnter(e, index)}
    			  onDragLeave={(e) => dragLeave(e, index)}
    			  onDragOver={(e) => dragOver(e, index)}
    			  onDragEnd={(e) => dragEnd(e, index)}
    			  onDrop={(e) => drop(e, index)} 
                  >
                  <TableCell style={{ width: "40%", paddingLeft: "0px" }}>
                    {imageLine.url}
                  </TableCell>
                  <TableCell style={{ width: "35%" }}>
                    {imageLine.categories ? imageLine.categories.replaceAll('&&&', ', ') : ''}
                  </TableCell>
                  <TableCell style={{ width: "15%" }}>
                    {imageLine.vendors ? imageLine.vendors.replaceAll('&&&', ', ') : ''}
                  </TableCell>
                  <TableCell style={{ width: "5%", paddingTop: "9px" }}>
                    {imageLine.promo && imageLine.promo == 1 ? <Check checked={true} /> : ''}
                  </TableCell>
                  <TableCell style={{ width: "1%" }}>
                    <Button
                      onClick={() => handleDeleteImage(index)}
                      color="inherit"
                      disableRipple
                      className={classes.editButton}
                    >
                      <Close className={classes.editIcon} />
                    </Button>
                  </TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </div>



    </div >
  )
}



export default withStyles(styles)(BannerEditor);